// import { configureStore } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';
// import { merchantReducer } from './merchant/reducer';

// const appReducer = combineReducers({
//     merchant: merchantReducer
// })

// export const store = configureStore({
//     reducer: appReducer,
// })


import { createStore } from 'redux';
import rootReducer from './rootReducer';

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('reduxState');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('reduxState', serializedState);
    } catch {
        // ignore write errors
    }
};

const persistedState = loadState();
export const store = createStore(rootReducer, persistedState);

store.subscribe(() => {
    saveState(store.getState());
});
